import type { RunMetricOutput } from "@/types/RunMetricOutput"
import {
  getMetricExecutionQuestion,
  getMetricRuntimeString,
} from "@/utils/metric-output-boundaries"

export function getMetricQuestionSection(
  mo: RunMetricOutput,
  configuredQuestion: string | undefined,
): { label: string; content: React.ReactNode } | null {
  const currentQuestionStr = configuredQuestion || ""
  const executionQuestionStr =
    getMetricExecutionQuestion(mo) ??
    getMetricRuntimeString(mo, "user_provided_prompt")
  const userProvidedPrompt = executionQuestionStr || currentQuestionStr

  if (!userProvidedPrompt) {
    return null
  }

  const isUsingOldVersion = Boolean(
    currentQuestionStr &&
    executionQuestionStr &&
    currentQuestionStr !== executionQuestionStr,
  )

  return {
    label: "Question",
    content: (
      <div
        className={`text-sm leading-relaxed whitespace-pre-wrap wrap-break-word ${isUsingOldVersion ? "text-coval-warning-text" : ""}`}
      >
        {userProvidedPrompt}
      </div>
    ),
  }
}
